import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  data: function data() {
    return {
      date: [],
      dialogShow: false,
      main_content: []
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      console.log("data==", data);
      this.main_content = [];
      var announce_template = JSON.parse(data.announce_template);
      announce_template.forEach(function (item) {
        _this.main_content.push({
          language: item.language,
          content: item.content,
          title: item.title
        });
      });
      this.dialogShow = true;
    }
  }
};